import * as React from "react";
const SvgNotification20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 18,
        height: 18,
        fill: "black",
        viewBox: "0 0 18 18"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M5 10c0 .783-.168 1.448-.464 2h8.928c-.296-.552-.464-1.217-.464-2V6a4 4 0 0 0-8 0v4Zm12 4v-1c0-1 .001-1 .002-1h.006H17l-.058-.003a2.687 2.687 0 0 1-.995-.266 1.635 1.635 0 0 1-.646-.551C15.14 10.94 15 10.575 15 10V6A6 6 0 0 0 3 6v4c0 .575-.14.94-.3 1.18-.165.246-.39.422-.647.55A2.688 2.688 0 0 1 1 12H.992 1v2h16Zm-8 2a1 1 0 0 1-1-1H6a3 3 0 1 0 6 0h-2a1 1 0 0 1-1 1Z",
      clipRule: "evenodd"
    })
  );
export default SvgNotification20Px;
